import React from 'react';

const navItems = [
  { key: 'dashboard', label: 'Dashboard', icon: 'fas fa-tachometer-alt', active: true },
  { key: 'billing', label: 'Billing History', icon: 'fas fa-file-invoice-dollar', active: false },
  { key: 'subscription', label: 'Subscription Changes', icon: 'fas fa-exchange-alt', active: false },
  { key: 'advanced', label: 'Advanced Configuration', icon: 'fas fa-cogs', active: false },
];

const SidebarNav: React.FC = () => {
  return (
    <div className="dashboard-tabs-nav w-100 mb-4">
      <ul className="nav nav-tabs flex-row justify-content-start">
        {navItems.map((item) => (
          <li className="nav-item" key={item.key}>
            <button
              className={`nav-link d-flex align-items-center${item.active ? ' active' : ''}`}
              style={{ cursor: 'pointer' }}
              disabled={!item.active} // Only Dashboard is active for now
            >
              <i className={`${item.icon} me-2`}></i>
              <span className="fw-bold small">{item.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarNav;
